/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RuoloDto } from '../../models/ruolo-dto';

export interface ApiAuthRuoloListGet$Params {}

export function apiAuthRuoloListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthRuoloListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<RuoloDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthRuoloListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<RuoloDto>>;
        }),
    );
}

apiAuthRuoloListGet.PATH = '/api/auth/ruolo-list';
